import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigService, constants, handleError} from '@q9elements/ui-kit/common';
import {CookieService} from 'ngx-cookie-service';
import {catchError, map, take, tap} from 'rxjs/operators';

import {environment} from '../../../environments/environment';
import {AttachmentsService} from '../../services/dao/attachments.service';
import {ImpactAssessmentStore} from './impact-assessment-store';

@Injectable({
  providedIn: 'root'
})
export class ImpactAssessmentService {
  apiEndpoint = ConfigService.environment.API_ENDPOINT;

  constructor(
    private http: HttpClient,
    private impactAssessmentStore: ImpactAssessmentStore,
    private attachmentsService: AttachmentsService,
    private cookieService: CookieService
  ) {}

  public fetchNodeData(refModelId: string, nodeId: string) {
    const url = `${environment.API_ENDPOINT}/refmodel/${refModelId}/node/${nodeId}`;
    return this.http.get(url).pipe(
      tap(nodeData => {
        this.impactAssessmentStore.set('nodeData', nodeData);
        return nodeData;
      })
    );
  }

  public fetchStoryAttachments(refModelId: string, nodeId: string) {
    const url = `${this.apiEndpoint}/refmodel/${refModelId}/node/${nodeId}/attachments`;

    return this.http.get(url).pipe(
      take(1),
      map((attachments: any) => attachments.storyAttachments)
    );
  }

  public fetchRefModelUsers(refModelId: string) {
    const url = `${this.apiEndpoint}/refmodel/${refModelId}/user`;

    return this.http.get(url).pipe(take(1));
  }

  public getGroups(teamId: string) {
    const url = `${this.apiEndpoint}/organizations/${teamId}/groups`;

    return this.attachmentsService.getGroups(url).pipe(take(1));
  }

  public fetchCopiedStory() {
    const copiedStory = this.cookieService.get(constants.cookie.copiedStoryKey);

    if (!copiedStory) {
      return void 0;
    }

    return JSON.parse(copiedStory);
  }

  public createStoryLink(url: string, data: any) {
    const urlFull = url + '/link/story';

    return this.http.post(urlFull, data).pipe(catchError(handleError()));
  }
}
